import { Inventario } from 'src/drheranca/types';

export interface AssetCategoryDef {
  key: keyof Inventario;
  label: string;
  rowDescription: string;
}

export const ASSET_CATEGORIES: AssetCategoryDef[] = [
  { key: 'imoveis', label: 'Imóveis', rowDescription: 'Soma dos imóveis cadastrados no espólio' },
  { key: 'veiculos', label: 'Veículos', rowDescription: 'Soma dos veículos cadastrados no espólio' },
  { key: 'investimentos', label: 'Investimentos', rowDescription: 'Soma dos investimentos cadastrados no espólio' },
  {
    key: 'participacoes_societarias',
    label: 'Participações Societárias',
    rowDescription: 'Soma das participações societárias cadastradas',
  },
  { key: 'creditos', label: 'Créditos', rowDescription: 'Soma dos créditos a receber do espólio' },
  { key: 'criptomoedas', label: 'Criptoativos', rowDescription: 'Soma dos criptoativos cadastrados no espólio' },
  { key: 'outros_bens', label: 'Outros Bens', rowDescription: 'Soma de outros bens cadastrados no espólio' },
  { key: 'bens_internacionais', label: 'Bens no Exterior', rowDescription: 'Soma dos bens cadastrados no exterior' },
  { key: 'seguros', label: 'Seguros', rowDescription: 'Soma dos seguros cadastrados no espólio' },
];
